import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';
import * as DateHelpers from './DateHelpers';

interface EditSiteTimesProps {
    jobId: number;
    runsheetId: number;
    showEditSiteTimesModal: boolean;
    hideModal(): void;
    save(onSiteMinutes: number, updateOnSiteMinutes: boolean): void;
}

interface ScheduleEstimatedTime {
    scheduleId: number;
    item: string;
    estimatedTime: string
}

const EditSiteTimesModal = (props: EditSiteTimesProps) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [onSiteMinutes, setOnSiteMinutes] = React.useState(0);
    const [schedEstTime, setSchedEstTime] = React.useState<ScheduleEstimatedTime[]>([]);

    React.useEffect(() => {
        if (props.runsheetId > 0) {
            getData(props.runsheetId);
        }
    }, [props.runsheetId]);

    const getData = async (runsheetId: number) => {
        const token = await authService.getAccessToken();

        axios.get('api/RunSheet/GetRunsheetOnSiteTimes?RunsheetId=' + runsheetId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setOnSiteMinutes(res.data.onSiteMinutes);
            setSchedEstTime(res.data.scheduleEstTime);
            setErrors({});
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const hideEditSiteTimesModal = () => {
        setOnSiteMinutes(0);
        props.hideModal();
    }

    const handleEstimatedTimeChange = (e: any, itemIndex: number) => {
        e.preventDefault();
        setErrors({});

        let schedItems = [...schedEstTime];
        let schedItem = schedItems[itemIndex];

        schedItem.estimatedTime = e.target.value;

        setSchedEstTime(schedItems);
    }

    const validate = () => {
        var formIsValid = true;
        let errorList: any = {};

        for(var i = 0; i < schedEstTime.length; i++) {
            var itemToCheck = schedEstTime[i];

            if (itemToCheck.estimatedTime == "" || itemToCheck.estimatedTime == "0") {
                formIsValid = false;
            } else if (!DateHelpers.validTimeAmount(itemToCheck.estimatedTime)) {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            errorList["estimatedTime"] = "Estimated Time cannot be blank and must be in a valid format, e.g. 0:30!";
            setErrors(errorList);
        }

        return formIsValid;
    }

    const save = (e:any, estTimeOnly: boolean) => {
        e.preventDefault();

        if (validate()) {
            saveTimes(estTimeOnly);
        } else {
            toast.error("Fix errors on screen before saving!");
        }
    }

    const saveTimes = async (estTimeOnly: boolean) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var saveOnSiteTimes = {
            jobId: props.jobId,
            runsheetId: props.runsheetId,
            estimatedTimeOnly: estTimeOnly,
            onSiteMinutes: onSiteMinutes,
            scheduleEstTime: schedEstTime,
            subId: user.sub
        };

        //save
        axios.post('api/RunSheet/SaveRunsheetOnSiteTimes', saveOnSiteTimes, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var updatedOnSiteMinutes = onSiteMinutes;   //to update runsheet screen
            setOnSiteMinutes(0);

            props.save(updatedOnSiteMinutes, !estTimeOnly);
        })
        .catch(error => {
            toast.error(error.message);
        }); 
    }

    const reset = (e: any) => {
        e.preventDefault();

        resetTimes();
    }

    const resetTimes = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var resetOnSiteTimes = {
            jobId: props.jobId,
            runsheetId: props.runsheetId,
            subId: user.sub
        };

        //save
        axios.post('api/RunSheet/ResetRunsheetOnSiteTimes', resetOnSiteTimes, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setOnSiteMinutes(0);

            props.save(-1, true);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <Modal show={props.showEditSiteTimesModal} onHide={hideEditSiteTimesModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Override minutes spent on site</Modal.Title>
                <button type="button" className="close" onClick={hideEditSiteTimesModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <span>For 0 minutes on the KPI Report, set the On Site Minutes to 0 and click Save. </span>
                <label className="input-group" htmlFor="onSiteMinutes">
                    <span className="label">On Site Minutes</span>
                    <input className="input" type="number" min={0} step={1} id="onSiteMinutes" name="onSiteMinutes" value={onSiteMinutes} onChange={(e) => setOnSiteMinutes(Number(e.target.value))}></input>
                </label>

                <span>Update Estimated Time/s</span>
                {schedEstTime.map((item, itemIndex) =>
                    <label key={item.scheduleId} className="input-group" htmlFor="estimatedTime">
                        <span className="label">{item.item}</span>
                        <input className="input" type="text" id="estimatedTime" name="estimatedTime" value={item.estimatedTime} onChange={(e) => handleEstimatedTimeChange(e, itemIndex)}></input>
                    </label>
                )}
                <span className={errors["estimatedTime"] ? "label errors marginLeftLabel" : "hidden"}>{errors["estimatedTime"]}</span>
            </Modal.Body>

            <Modal.Footer>
                <div className="defaultbutton__container--left makeitfullwidth">
                    <span className="makeititalic">Reset will clear minutes and use times entered</span>
                </div>
                <div className="makeitflexspacebetween makeitfullwidth">
                    <button className="popup-button--no" onClick={reset}>Reset</button>
                    <button className="popup-button--yes" onClick={(e) => save(e, true)}>Save Estimate Time ONLY</button>
                    <button className="popup-button--yes" onClick={(e) => save(e, false)}>Save</button>
                </div>
            </Modal.Footer>
        </Modal>
    );
    

    let contents =
        props.runsheetId < 1 ? <div></div> :
        loading ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );
}

export default EditSiteTimesModal;